<template>
  <div class="sale-customer-page" v-loading="pageLoading" element-loading-text="加载中...">
    <div class="sale-page-header">
      <div class="sale-page-header__top">
        <div class="sale-page-header__left">
          <h2 class="sale-page-title">{{ pageTitle }}</h2>
          <span class="sale-page-desc">{{ pageDesc }}</span>
        </div>
      </div>
      <div class="sale-query-bar">
        <div class="sale-query-item sale-query-item--date-pair">
          <label>{{ $t('sale.order.saleTime') }}</label>
          <el-date-picker
            v-model="formInline.begin"
            type="date"
            size="small"
            :placeholder="$t('sale.common.startDate')"
          ></el-date-picker>
          <span class="sale-date-sep">至</span>
          <el-date-picker
            v-model="formInline.end"
            type="date"
            size="small"
            :placeholder="$t('sale.common.endDate')"
          ></el-date-picker>
        </div>
        <div class="sale-query-item">
          <label>{{ $t('sale.customer.name') }}</label>
          <el-input
            v-model="formInline.name"
            type="text"
            size="small"
            :placeholder="$t('sale.customer.inputName')"
          ></el-input>
        </div>
        <div class="sale-query-item">
          <label>{{ $t('sale.customer.idNo') }}</label>
          <el-input
            v-model="formInline.nationalId"
            type="text"
            size="small"
            :placeholder="$t('sale.customer.inputIdNo')"
          ></el-input>
        </div>
        <div class="sale-query-item" v-if="!asOrderRecord">
          <label>{{ $t('sale.order.settleStatus') }}</label>
          <el-select v-model="formInline.status" :placeholder="$t('sale.order.settleStatus')" size="small" clearable>
            <el-option :label="$t('sale.common.all')" value=""></el-option>
            <el-option :label="$t('sale.common.unsettled')" value="2"></el-option>
            <el-option :label="$t('sale.common.settled')" value="1"></el-option>
          </el-select>
        </div>
        <div class="sale-query-item" v-if="category != 1">
          <label>{{ channelLabel }}</label>
          <el-select
            v-model="formInline.subChannel"
            clearable
            :placeholder="channelLabel"
            size="small"
          >
            <el-option
              v-for="(item, index) in listchannel"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </div>
        <div class="sale-query-item" v-else>
          <label>{{ channelLabel }}</label>
          <el-select
            v-model="formInline.branchId"
            clearable
            :placeholder="channelLabel"
            size="small"
          >
            <el-option
              v-for="(item, index) in listchannel"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </div>
        <div class="sale-page-header__actions">
          <el-button size="small" type="primary" @click="getData()">{{ $t('sale.order.search') }}</el-button>
          <el-button size="small" plain type="primary" @click="exportsee">{{ $t('sale.order.export') }}</el-button>
        </div>
      </div>
    </div>

    <section class="sale-panel sale-panel--table">
      <div class="sale-panel__head">
        <span>{{ listTitle }}</span>
        <span class="sale-panel__count">{{ $t('sale.order.total', { n: allpage }) }}</span>
      </div>
      <div class="table">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="100%"
      >
        <el-table-column :label="$t('col.userName')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.name || $t('sale.customer.pendingActive') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('col.productName')" align="center">
          <template slot-scope="scope">
            <span>{{ $tCommodityName(scope.row.product && scope.row.product.name) || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('col.mobile')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.mobileno || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('col.idNo')" align="center" width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.nationalId || $t('sale.customer.pendingActive') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('col.validFrom')" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.detail.validFrom
                ? setTime(scope.row.detail.validFrom)
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('col.validUtil')" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.detail.validUtil
                ? setTime(scope.row.detail.validUtil - 1000)
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!asOrderRecord" prop="code" :label="$t('col.cardNo')" align="center">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="$t('sale.customer.copyCode')"
              placement="top"
            >
              <a
                :data-clipboard-text="scope.row.detail.code"
                class="copeA icon-copy"
                >{{ scope.row.detail.code }}</a
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column v-if="asOrderRecord" :label="$t('col.amount')" align="center" width="120">
          <template slot-scope="scope">
            <span class="yellow">￥{{ (scope.row.detail.amount || 0) / 100 }}{{ $t('sale.common.yuan') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="policyNo"
          :label="$t('col.policyNo')"
          align="center"
          width="190px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.product.productGroup == 'G220'">
              <span >--</span>
            </span>
            <span v-else>
              <span v-if="!scope.row.detail.policyNo">--</span>
            <a
              v-else
              :href="scope.row.detail.policyUrl"
              target="_blank"
              class="blue"
              >{{ scope.row.detail.policyNo }}</a
            >
            </span>
          
          </template>
        </el-table-column>
        <el-table-column v-if="!asOrderRecord" :label="$t('col.activateUrl')">
          <template slot-scope="scope">
            <div v-if="scope.row.detail.validFrom == undefined" class="sale-active-cell">
              <a
              :data-clipboard-text="scope.row.activeUrl"
              class="blue icon-copy"
              >{{ $t('sale.customer.copyActiveUrl') }}</a
              >
              <span class="blue sale-qr-link" @click="ckewm(scope.row.activeUrl)">{{ $t('sale.customer.viewQr') }}</span>
            </div>
            <!-- :logoSrc="imagePath" -->
            <span v-else class="sale-activated">{{ $t('sale.customer.activated') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="channelLabel" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.subChannelName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column slot-scope="scope" v-if="scope.row.divisionDay == 1 || scope.row.divisionDay == 3"  label="天数">
					<template slot-scope="scope">
				
						<span >{{scope.row.continueDay}}日</span>
					</template>
				</el-table-column> -->
        <el-table-column :label="$t('col.op')" align="center" width="380" class-name="sale-op-col">
          <template slot-scope="scope">
            <div class="sale-op-row">
              <span class="sale-status">{{
                billingState[scope.row.detail.billingState]
              }}</span>
              <el-tooltip effect="dark" :content="$t('sale.customer.activateFirst')" placement="top">
                <span
                  v-if="!scope.row.detail.validFrom"
                  class="sale-disabled-link"
                  >{{ $t('op.viewCredential') }}</span
                >
              </el-tooltip>
              <template v-if="scope.row.detail.validFrom">
                <el-button
                  v-if="!scope.row.detail.serviceCredential"
                  type="text"
                  disabled
                  class="sale-op-btn"
                  ><i class="el-icon-loading"></i>{{ $t('op.generating') }}</el-button
                >
                <a
                  v-if="scope.row.detail.serviceCredential"
                  :href="scope.row.detail.serviceCredential"
                  target="_blank"
                  class="blue"
                  >{{ $t('op.viewCredential') }}</a
                >
              </template>
              <router-link
                class="blue"
                v-if="channelId == '2753' || channelId == '2137' || channelId == '2108'"
                :to="{
                  path: detailBasePath,
                  query: {
                    id: scope.row.detail.id,
                    type: 'type',
                    visaCenter: scope.row.detail.subChannelName || ''
                  },
                }"
                >{{ $t('op.detail') }}</router-link
              >
              <router-link
                class="blue"
                v-else
                :to="{
                  path: detailBasePath,
                  query: {
                    id: scope.row.detail.billingId,
                    visaCenter: scope.row.detail.subChannelName || ''
                  },
                }"
                >{{ $t('op.detail') }}</router-link
              >
              <el-button
                v-if="
                  scope.row.detail.billingState == 0 ||
                  scope.row.detail.billingState == 4 ||
                  (scope.row.detail.validFrom &&
                    scope.row.detail.validFrom < scope.row.detail.nowTime)
                "
                type="text"
                disabled
                class="sale-op-btn"
                >{{ $t('op.refund') }}</el-button
              >
              <el-button
                v-else-if="
                  scope.row.detail.validFrom != undefined &&
                  scope.row.detail.parentId != null
                "
                type="text"
                disabled
                class="sale-op-btn"
                >{{ $t('op.refund') }}</el-button
              >
              <el-button
                v-else
                type="text"
                class="sale-op-btn"
                @click="
                  centerDialogVisible = true;
                  exitData = scope.row.detail;
                "
                >{{ $t('op.refund') }}</el-button
              >
              <!-- <span v-if="scope.row.detail.includeInsurance == 0">
                <el-button v-if="scope.row.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
            </div>
            <!-- <el-button v-if="scope.row.validFrom != undefined&&">开发票</el-button>
						<el-button v-else type='text'>开发票</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

      <div class="fenye">
        <pages
          class="pagination"
          :allpage="allpage"
          :changePage="changePage"
        ></pages>
      </div>
    </section>

    <el-dialog
      :title="$t('dialog.tip')"
      :visible.sync="centerDialogVisible"
      width="420px"
      center
      custom-class="sale-dialog sale-dialog--tip"
    >
      <div class="sale-dialog-tip sale-dialog-tip--warn">{{ $t('dialog.confirmRefund') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('op.cancel') }}</el-button>
        <el-button type="primary" @click="sureExit">{{ $t('op.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('dialog.friendTip')"
      :visible.sync="centerDialogVisible1"
      width="480px"
      center
      custom-class="sale-dialog"
    >
      <template v-for="(item, index) in exitData.invoices">
        <refundDialog
          :key="index"
          :fpdm="item.fpdm"
          :fphm="item.fphm"
          :prodectName="exitData.product.name"
        />
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible1 = false"
          >{{ $t('op.confirm') }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('dialog.qrcode')"
      :visible.sync="ewmcenterDialogVisible"
      width="420px"
      center
      custom-class="sale-dialog"
    >
      <div class="sale-qr-wrap">
        <vue-qr class="fukuanBox" :logoSrc="imagePath" :text="payImg" :size="260"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="ewmcenterDialogVisible = false">{{ $t('op.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  ordergetChannelBillDetailList,
  listDd,
  refund,
  downloadPdf,
  listchannel,
  userchannellist,
  getInfo,
} from "@/axios/api.js";
import common from "@/assets/common.js";
import Clipboard from "clipboard";
import { Loading } from "element-ui";
import axios from "axios";
import vueQr from 'vue-qr';
import refundDialog from "@/components/refundDialog";
export default {
  props: {
    /**
     * 作为订单记录页嵌入时：文案仍显示「订单记录」，详情跳转订单记录路径
     */
    asOrderRecord: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ewmcenterDialogVisible:false,
      payImg:'',
      imagePath:require('../../assets/img/logo2.png'),
      category: window.localStorage.getItem("category"),
      channelId: "",
      listchannel: [],
      searchText: "",
      tableData: [],
      tableData4: [],
      formInline: {
        time: "",
        status: "",
        subChannel: "",
        begin: "", //开始时间
        end: "", //结束时间
        name: "", //姓名
        nationalId: "", //证件号
        branchId: "",
      },

      allpage: 0, //数据总数
      pageLoading: false,
      centerDialogVisible: false,
      centerDialogVisible1: false,
      exitData: {},
    };
  },

  components: {
    refundDialog,
    vueQr
  },
  computed: {
    /**
     * 页面标题（订单记录模式仍叫订单记录）
     * @returns {string}
     */
    pageTitle() {
      return this.asOrderRecord
        ? this.$t('sale.order.title')
        : this.$t('sale.customer.title')
    },
    /**
     * 页面描述
     * @returns {string}
     */
    pageDesc() {
      return this.asOrderRecord
        ? this.$t('sale.order.desc')
        : this.$t('sale.customer.desc')
    },
    /**
     * 列表标题
     * @returns {string}
     */
    listTitle() {
      return this.asOrderRecord
        ? this.$t('sale.order.list')
        : this.$t('sale.customer.list')
    },
    /**
     * 详情页路径
     * @returns {string}
     */
    detailBasePath() {
      return this.asOrderRecord
        ? '/sale/order/orderDetails'
        : '/sale/Orderdetails1/orderDetails'
    },
    /**
     * 渠道/签证中心筛选项与列表列文案
     * @returns {string}
     */
    channelLabel() {
      return this.asOrderRecord
        ? this.$t('sale.order.visaCenter')
        : this.$t('sale.order.channel')
    },
    /**
     * 财务状态文案（随语言切换更新）
     * @returns {string[]}
     */
    billingState() {
      void this.appLocale;
      return [
        this.$t("billing.0"),
        this.$t("billing.1"),
        this.$t("billing.2"),
        this.$t("billing.3"),
        this.$t("billing.4"),
        this.$t("billing.5"),
      ];
    },
  },
  methods: {
    ckewm(url) {
      this.payImg = url
      this.ewmcenterDialogVisible = true
      console.log(url)
    },
    changePage(start, count) {
      this.getData(start, count);
    },
    setTime(str) {
      return common.time(str);
    },
    getData(start, count) {
      var start = start || 0; //当前页
      var count = count || 10; //每页多少个
      this.pageLoading = true;
      var day = "";
      if (this.formInline.time) {
        day = common.time1(this.formInline.time);
      }

      // if (this.formInline.begin) {
      // 	begin = common.time1(this.formInline.begin)
      // }
      // if (this.formInline.end) {
      // 	end = common.time1(this.formInline.end)
      // }
      console.log(this.formInline.end, this.formInline.begin);
      if (this.formInline.begin != "") {
        if (this.formInline.begin != null) {
          var begin = Date.parse(new Date(this.formInline.begin));
        } else {
          var begin = "";
        }
      }
      if (this.formInline.end != "") {
        if (this.formInline.end != null) {
          var end1 = Date.parse(new Date(this.formInline.end));
          var end = end1 + 24 * 60 * 60 * 1000 - 1;
        } else {
          var end = "";
        }
      }

      var data = {};
      if (window.localStorage.getItem("category") != 1) {
        if (this.formInline.subChannel != "") {
          data = {
            start,
            count,
            day,
            subChannel: this.formInline.subChannel,
            branchId:this.channelId,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        } else {
          data = {
            start,
            count,
            day,
            branchId:this.channelId,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        }
      } else {
        if (this.formInline.branchId != "") {
          data = {
            start,
            count,
            day,
            branchId: this.formInline.branchId,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        } else {
          data = {
            start,
            count,
            day,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        }
      }

      getInfo()
        .then((res) => {
          console.log(res.data.obj.category);
          var datalist = {
            start: "0",
            count: 10000,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
          if (data.day != "") {
            datalist.day = data.day;
          }
          if (res.data.obj.category != 1) {
            listchannel(datalist)
              .then((resa) => {
                console.log(resa, "215");
                if (resa.data.code == 0) {
                  this.listchannel = resa.data.obj;
                  this.ordergetChannelBillDetailList(data)
                  // this.formInline.subChannel=this.listchannel[0].id
                  // subChannel
                } else {
                  this.pageLoading = false;
                }
              })
              .catch((err) => {
                console.log(err);
                this.pageLoading = false;
              });
          } else {
            userchannellist(datalist)
              .then((resb) => {
                console.log(resb, "335");
                if (resb.data.code == 0) {
                  this.listchannel = resb.data.obj;
                  this.ordergetChannelBillDetailList(data)
                  // this.formInline.subChannel=this.listchannel[0].id
                  // subChannel
                } else {
                  this.pageLoading = false;
                }
              })
              .catch((err) => {
                console.log(err);
                this.pageLoading = false;
              });
          }
        })
        .catch((err) => {
          console.log(err);
          this.pageLoading = false;
        });
      

   
      if (this.formInline.begin != "") {
        if (this.formInline.begin != null) {
          var begin = Date.parse(new Date(this.formInline.begin));
        } else {
          var begin = "";
        }
      }
      if (this.formInline.end != "") {
        if (this.formInline.end != null) {
          var end1 = Date.parse(new Date(this.formInline.end));
          var end = end1 + 24 * 60 * 60 * 1000 - 1;
        } else {
          var end = "";
        }
      }
    },
    ordergetChannelBillDetailList(data) {
      ordergetChannelBillDetailList(data)
        .then((res) => {
          //  this.creatData=res.data.obj;
          res.data.obj.forEach((item) => {
            // console.log(item.detail.subChannel);
            for (var i = 0; i < this.listchannel.length; i++) {
              // console.log(this.listchannel[i].id)
              if(this.category != 1) {
                if (this.listchannel[i].id == item.detail.subChannel) {
                item.detail.subChannelName = this.listchannel[i].name;
                }
              }else {
                if (this.listchannel[i].id == item.detail.channelId) {
                item.detail.subChannelName = this.listchannel[i].name;
                }
              }
            
            }
            if (item.detail.extra != null) {
              try{item.detail.extra = JSON.parse(item.detail.extra);}catch(e){}
            }
            item.divisionDay = item.product.divisionDay;
            item.detail.mobileno = Number(item.detail.mobileno);
          });
          this.tableData = res.data.obj;
         
       

          this.allpage = res.data.total;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    exportsee() {
      var token = JSON.parse(window.localStorage.getItem("token")).data.obj
        .token;
      var day = common.time1(this.formInline.time);
      // var begin = common.time1(this.formInline.begin)
      // var end = common.time1(this.formInline.end)
      // name:this.formInline.name, //姓名
      // nationalId:this.formInline.nationalId// 证件号
      console.log(this.formInline.begin);
      if (this.formInline.begin != "") {
        if (this.formInline.begin != null) {
          var begin = Date.parse(new Date(this.formInline.begin));
        } else {
          var begin = "";
        }
      }
      if (this.formInline.end != "") {
        if (this.formInline.end != null) {
          var end1 = Date.parse(new Date(this.formInline.end));
          var end = end1 + 24 * 60 * 60 * 1000 - 1;
        } else {
          var end = "";
        }
      }
      console.log(end, begin);
      if (end == undefined) {
        end = "";
      }
      if (begin == undefined) {
        begin = "";
      }
      if (window.localStorage.getItem("category") != 1) {
        if (this.channelId == "2753" || this.channelId == "2137" || this.channelId == "2108") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.channelId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=1`;
        } else if(this.channelId == "3312" || this.channelId == "3118" || this.channelId == "1477") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.channelId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=3`;
        } else {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.channelId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=2`;
        }
      }else {
        if(this.formInline.branchId != '') {
          if (this.channelId == "2753" || this.channelId == "2137" || this.channelId == "2108") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.formInline.branchId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=1`;
        } else if(this.channelId == "3312" || this.channelId == "3118" || this.channelId == "1477") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.formInline.branchId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=3`;
        }else {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.formInline.branchId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=2`;
        }
        }else {
        if (this.channelId == "2753" || this.channelId == "2137" || this.channelId == "2108") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=1`;
        }else if(this.channelId == "3312" || this.channelId == "3118" || this.channelId == "1477") {
          window.location = `${SEVERS}rescue_sale/order/exportOrderList?day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=3`;
        } else {
          window.location = `${SEVERS}rescue_sale/order/exportOrderList?day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=2`;
        }
        }
      }
      console.log(window.location)
    },
    sureExit() {
      //退单
      console.log();
      var exitData = this.exitData.id;
      var data = {
        billDetailId: exitData,
      };
      refund(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "退单成功！",
              type: "success",
            });
            this.getData();
            this.centerDialogVisible1 = true;
          } else if (res.data.code == 105009) {
            this.$message.error("保障卡已激活不能退款！");
          } else if (res.data.code == 105014) {
            this.$message.error("退单失败！");
          } else if (res.data.code == 105015) {
            this.$message.error("部分退单失败！");
          } else if (res.data.code == 105042) {
            this.$message.error("部分退单失败！");
          }
          this.centerDialogVisible = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changePage(size, each) {
      this.getData(size, each);
    },
    downPdf(id) {
      var loadingInstance = Loading.service({ fullscreen: true });
      const httpAxios = axios.create(); //创建实例
      httpAxios.defaults.timeout = 1000 * 60 * 2;
      httpAxios
        .get(API_BASE_EWM + "rescue_sale/sale/download_pdf", {
          params: {
            token: JSON.parse(window.localStorage.getItem("token")).data.obj
              .token,
            id,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            loadingInstance.close();
            window.location = res.data.obj;
          }
        })
        .catch((err) => {
          console.log(err);
          loadingInstance.close();
        });
    },
  },
  mounted() {
    this.channelId = localStorage.getItem("channelId");
    this.getData();
    const clipboard = new Clipboard(".icon-copy");
    clipboard.on("success", (e) => {
      this.$message.success(e.text + " 已复制到剪贴板！");
    });
    clipboard.on("error", (e) => {
      console.log("该浏览器不支持自动复制");
      clipboard.destroy();
    });
  },
};
</script>
<style>
.has-gutter th {
  background-color: #f5f7fb;
}
.sale-dialog {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(15, 35, 52, 0.18);
}
.sale-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #ebeef5;
  background: #f7f9fc;
}
.sale-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.sale-dialog .el-dialog__body {
  padding: 20px 24px;
  color: #606266;
}
.sale-dialog .el-dialog__footer {
  padding: 12px 20px 18px;
  border-top: 1px solid #ebeef5;
  background: #fafbfc;
}
.sale-dialog-tip {
  text-align: center;
  font-size: 16px;
  line-height: 1.6;
  color: #303133;
  padding: 12px 8px;
}
.sale-dialog-tip--warn {
  color: #e6a23c;
}
</style>
<style scoped="scoped">
.sale-customer-page {
  --sale-primary: #00abfa;
  --sale-text: #303133;
  --sale-muted: #909399;
  --sale-border: #ebeef5;
  --sale-bg: #f7f9fc;
  --sale-radius: 8px;
  color: var(--sale-text);
  height: 100%;
  max-height: calc(100vh - 94px);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.sale-page-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--sale-border);
  border-radius: var(--sale-radius);
  flex-shrink: 0;
  position: relative;
  z-index: 5;
}

.sale-page-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.sale-page-header__left {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

.sale-page-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: auto;
}

.sale-page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--sale-text);
  line-height: 1.3;
  white-space: nowrap;
}

.sale-page-desc {
  margin: 0;
  font-size: 13px;
  color: var(--sale-muted);
  line-height: 1.3;
  white-space: nowrap;
}

.sale-query-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
  overflow: visible;
}

.sale-query-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.sale-query-item label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.sale-query-item .el-select,
.sale-query-item .el-input {
  width: 120px;
}

.sale-query-item--date-pair >>> .el-date-editor {
  width: 120px;
}

.sale-date-sep {
  color: #909399;
  font-size: 13px;
  padding: 0 2px;
}

.sale-panel {
  background: #fff;
  border: 1px solid var(--sale-border);
  border-radius: var(--sale-radius);
  overflow: hidden;
}

.sale-panel--table {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.sale-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: var(--sale-bg);
  border-bottom: 1px solid var(--sale-border);
  font-size: 14px;
  font-weight: 600;
  color: var(--sale-text);
  flex-shrink: 0;
}

.sale-panel__count {
  font-size: 12px;
  font-weight: 400;
  color: var(--sale-muted);
}

.table {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
}

.table >>> .el-table {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100% !important;
}

.table >>> .el-table th {
  color: #606266;
  font-weight: 600;
  padding: 10px 0;
  background-color: #f5f7fb;
}

.table >>> .el-table td {
  padding: 8px 0;
  background-color: #fff;
}

.table >>> .el-table__body tr:hover > td {
  background-color: #f5f7fa !important;
}

.table >>> .el-table td.sale-op-col {
  background-color: #fff !important;
}

.table >>> .el-table__body tr:hover > td.sale-op-col {
  background-color: #f5f7fa !important;
}

.fenye {
  flex-shrink: 0;
  padding: 10px 16px;
  border-top: 1px solid var(--sale-border);
  background: #fff;
  display: flex;
  justify-content: flex-end;
}

.sale-op-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 2px 8px;
  max-width: 100%;
}

.sale-op-row .blue,
.sale-op-row .sale-disabled-link,
.sale-op-row .sale-status {
  margin: 0;
  flex-shrink: 0;
}

.sale-op-row >>> .el-button--text {
  padding: 0;
  margin: 0;
  flex-shrink: 0;
}

.sale-op-btn {
  padding: 0 !important;
  margin: 0 !important;
}

.blue {
  color: var(--sale-primary);
  cursor: pointer;
}

.blue:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.sale-status {
  color: #e6a23c;
  font-size: 12px;
}

.sale-disabled-link {
  color: #c0c4cc;
  cursor: pointer;
}

.sale-active-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.sale-qr-link {
  margin: 0;
}

.sale-activated {
  color: #67c23a;
}

.sale-qr-wrap {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}

.input {
  width: 400px;
}

@media (max-width: 1280px) {
  .sale-query-item .el-select,
  .sale-query-item .el-input {
    width: 110px;
  }
  .sale-query-item--date-pair >>> .el-date-editor {
    width: 110px;
  }
  .sale-query-bar {
    gap: 6px 8px;
  }
}

@media (max-width: 768px) {
  .sale-customer-page {
    height: auto;
    max-height: none;
    overflow: visible;
  }
  .sale-page-header__top {
    flex-direction: column;
    align-items: stretch;
  }
  .sale-query-bar {
    flex-wrap: wrap;
  }
  .sale-page-header__actions {
    margin-left: 0;
    justify-content: flex-end;
    width: 100%;
  }
  .sale-panel--table {
    min-height: 420px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/sale/Orderdetails1.vue